export const ERROR_MESSAGE_FETCH =
  'Something went wrong. Please try again in some time.';
